import React, { Component } from 'react';
import ReactSparkTextInput from '../../../widgets/ReactSparkTextInput';
import { connect } from 'react-redux';
import { onThemePropChange, parseUrlProperty } from '../../../helpers/ThemeStoreHelpers';
import store from '../../../../store/Store';
import ModalAssetBrowser from '../../../widgets/ModalAssetBrowser';
import { PresetColorPicker, ReactSparkSelectInput } from '../../../widgets/index';
import { Service as FileService } from '../../../../services/Service';
import { fontWeight, imageHeight } from '../../../../constants/availableFonts';
import BackgroundPicker from '../../../widgets/BackgroundPicker';
import { CATEGORIES } from '../../../../services/fileUpload/uploadFile';
import ModalGenericPropertyValues from '../../../modals/ModalGenericPropertyValues';

class HeroImageStyles extends Component {
    render() {
        const hotelMaxWidthOptions = [
            { key: '100%', label: '100%' },
            ..._.range(50, 900, 50).map(v => ({ key: v.toString(), label: v.toString() }))];

        return (
            <div>
                <h4>Hero Image</h4>
                <div className="row">
                    <div></div>
                    <div className="col-xs-12">
                        Hotel Details Background
                        <BackgroundPicker
                            background={this.props.heroImage.hotelDetails.background}
                            preset={this.props.themeColors.primary.colors}
                            isDisabled={this.props.isDisabled}
                            onChange={property =>
                                this.props.onThemePropChange('hotelDetails.background')({
                                    target: {
                                        value: property
                                    }
                                })
                            }
                        />
                    </div>
                    <div className="col-xs-12 col-sm-4">
                        <ReactSparkSelectInput
                            label="Image Height(tablet)"
                            onChange={this.props.onThemePropChange('height.tablet')}
                            isDisabled={this.props.isDisabled}
                            defaultValue={this.props.heroImage.height.tablet}
                            values={imageHeight.map(v => ({ key: v.toString(), label: v.toString() }))}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-4">
                        <ReactSparkSelectInput
                            label="Image Height(desktop)"
                            onChange={this.props.onThemePropChange('height.desktop')}
                            isDisabled={this.props.isDisabled}
                            defaultValue={this.props.heroImage.height.desktop}
                            values={imageHeight.map(v => ({ key: v.toString(), label: v.toString() }))}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-4">
                        <ReactSparkSelectInput
                            label="Hotel Max Width"
                            onChange={this.props.onThemePropChange('hotelDetails.maxWidth')}
                            isDisabled={this.props.isDisabled}
                            defaultValue={this.props.heroImage.hotelDetails.maxWidth}
                            values={hotelMaxWidthOptions}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-4">
                        <ReactSparkSelectInput
                            label="Link Font Weight"
                            onChange={this.props.onThemePropChange('hotelDetails.link.fontWeight')}
                            isDisabled={this.props.isDisabled}
                            defaultValue={this.props.heroImage.hotelDetails.link.fontWeight}
                            values={fontWeight.map(v => ({ key: v.toString(), label: v.toString() }))}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-3">
                        Link Color
                        <PresetColorPicker
                            isDisabled={this.props.isDisabled}
                            color={this.props.heroImage.hotelDetails.link.color}
                            onColorChange={this.props.onThemePropChange('hotelDetails.link.color')}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-4">
                        <ReactSparkSelectInput
                            label="Hotel Font Weight"
                            onChange={this.props.onThemePropChange('hotelDetails.fontWeight')}
                            isDisabled={this.props.isDisabled}
                            defaultValue={this.props.heroImage.hotelDetails.fontWeight}
                            values={fontWeight.map(v => ({ key: v.toString(), label: v.toString() }))}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-3">
                        Hero Image Color
                        <PresetColorPicker
                            isDisabled={this.props.isDisabled}
                            color={this.props.heroImage.hotelDetails.color}
                            onColorChange={this.props.onThemePropChange('hotelDetails.color')}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-3 col-lg-11 top-margin">
                        <ReactSparkTextInput
                            label="Hero Image URL"
                            isDisabled={this.props.isDisabled}
                            value={parseUrlProperty(this.props.heroImage.background)}
                            onChange={e => {
                                e.target.value
                                    ? this.props.onThemePropChange('background')(`url('${e.target.value}')`)
                                    : this.props.onThemePropChange('background')('');
                            }}
                        />
                    </div>
                    <div className="col=lg=1 col-xs-1 col-sm-1 top-margin modal-asset-browser-generic-values">
                        <ModalAssetBrowser
                            category={CATEGORIES.IMAGE}
                            isDisabled={this.props.isDisabled}
                            store={store}
                            onSelect={assets => {
                                if (assets.length >= 1) {
                                    let asset = assets[0];
                                    this.props.onThemePropChange('background')(
                                        `url('${FileService.assetUrl(
                                            asset.chainid,
                                            asset.hotelid,
                                            null,
                                            this.props.level,
                                            asset.filename,
                                            false,
                                            CATEGORIES.IMAGE
                                        )}')`
                                    );
                                }
                            }}
                        />
                        {false && <ModalGenericPropertyValues configName="Hero Image" />}
                    </div>
                </div>
            </div>
        );
    }
}

const mapHeaderStylesStateToProps = (state, ownProps) => ({
    page: state.app.data.theme.page,
    heroImage: state.app.data.theme.header.heroImage,
    themeColors: state.app.data.theme.colors,
    level: state.app.selected.level
});

const mapHeaderStylesDispatchToProps = dispatch => ({
    onThemePropChange: onThemePropChange(dispatch, 'header.heroImage')
});

export default connect(mapHeaderStylesStateToProps, mapHeaderStylesDispatchToProps)(HeroImageStyles);



// WEBPACK FOOTER //
// ./src/components/pages/theme/header/HeroImageStyles.js